import auth from '@/middleware/auth'
import { RESOURCE_CONFIGURATION } from '@/shared/constants/resources'

export default [
  {
    path: '/log-migration',
    meta: {
      middleware: [auth],
      resource: RESOURCE_CONFIGURATION,
      headerVisible: false,
    },
    name: 'logMigration',
    component: () => import('@/views/log-migration/List.vue'),
  },
]
